module.exports = __webpack_public_path__ + "static/media/Vintage 57 VR.c63c4ca.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Vintage 57 VR.mp3
// module id = r1x4
// module chunks = 12